import React, {useState} from 'react'
import {makeStyles, Typography} from '@material-ui/core';
import GridBlock from 'components/GridBlock';
import DeleteIcon from '@material-ui/icons/Delete'
import Tr from 'translations/Translations';
import clsx from 'clsx';
import Button from "components/Button";
import {VALUES} from "../constants/AuditTaskStatus";
import Confirm from "components/popup/confirm/Confirm";
import LoadingScreen from "components/complex/loadingScreen/LoadingScreen";
import {withRouter} from "react-router";
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import {LABELS} from '../constants/AuditTaskStatus'
import AuditTaskService from "../service/AuditTaskService";
import RouterPath, {createPath} from "../../../../libs/RouterPath";

const useStyle = makeStyles(theme => ({
    root: {},
    item: {
        '&:first-child': {
            width: 'calc(100% - 300px)'
        },
        '&:nth-child(2)': {
            width: 'calc(100% - 300px)'
        }
    },
    title: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    titleWrapped: {
        whiteSpace: 'nowrap'
    },
    label: {
        fontWeight: theme.typography.fontWeightBold
    },
    button: {
        marginRight: theme.spacing(1),
    }
}));

function AuditBarTitle(
    {
        taskId,
        title,
        status
    }) {

    const classes = useStyle();
    const [openDelete, setOpenDelete] = useState(false)
    const [working, setWorking] = useState(false)

    const deletable = !!taskId && status === VALUES.PREPARING;

    const handleDelete = () => {
        setOpenDelete(false);
        setWorking(true);
        AuditTaskService.deleteTask(taskId).then(() => {
            const path = createPath(RouterPath.audit.AUDIT_LIST_ADMIN);
            RouterPath.redirect(path);
        });
    }

    return (
        <>
            <GridBlock alignItems='center' justify='space-between' gridClasses={{root: classes.root, item: classes.item}}>
                <Typography variant='h6' className={clsx(classes.title, {[classes.titleWrapped]: true})}>
                    <b>{Tr('name')}:{' '}</b>{!!title ? title : Tr('audit_task_new_title')}
                </Typography>
                <Typography variant='body1' className={clsx(classes.title, {[classes.titleWrapped]: true})}>
                    <b>{Tr('status')}:{' '}</b>{status ? LABELS[status] : ''}
                </Typography>
                <GridBlock>
                    {deletable && <Button
                        variant='outlined'
                        size='small'
                        color='primary'
                        className={classes.button}
                        onClick={() => setOpenDelete(true)}
                        disabled={false}
                    >
                        {<DeleteIcon />}
                        {Tr('delete')}
                    </Button>}
                </GridBlock>
            </GridBlock>
            <Confirm
                open={openDelete}
                onConfirm={handleDelete}
                onCancel={() => setOpenDelete(false)}
                confirmText="audit_task_delete_confirm"
                confirmText2="delete_popup_text2"
            />
            {working ? <LoadingScreen/> : ''}
        </>
    )

}

AuditBarTitle.propTypes = {
    classes: PropTypes.any
}


export default connect((state) => ({
}), {})(withRouter(AuditBarTitle));
